import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Input,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import { ToastContainer, toast } from "react-toastify";

const user_info = JSON.parse(localStorage.getItem("user-info"));

const SmeTransitionV2List = () => {
  const history = useHistory();
  const [listData, setListData] = useState([]);
  const [summary, setSummary] = useState({
    total: 0,
    not_started: 0,
    in_progress: 0,
    completed: 0,
  });
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sendUpdatePopup, setSendUpdatePopup] = useState(false);
  const [recipientInput, setRecipientInput] = useState("");
  const [confirmStep, setConfirmStep] = useState(false);
  const [sending, setSending] = useState(false);

  const canSendUpdate =
    user_info &&
    (user_info.rolename === "admin" ||
      user_info.rolename === "manager" ||
      (user_info.rolename === "qanalyst" &&
        (user_info.role_id == 2 || user_info.role_id == 15)));

  useEffect(() => {
    getListData();
  }, [sortOrder, filterStatus]);

  function getListData(search) {
    const searchVal = search !== undefined ? search : searchText;
    clientmanageService
      .getTransitionV2List(1, searchVal, filterStatus, sortField, sortOrder)
      .then((response) => {
        if (response && response.status === 200) {
          setListData(response.data.data || []);
          if (response.data.summary) {
            setSummary(response.data.summary);
          }
        }
      });
  }

  function handleSearch(e) {
    setSearchText(e.target.value);
    getListData(e.target.value);
  }

  function sortTable(field) {
    setSortField(field);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  }

  function downloadReport() {
    clientmanageService.exportTransitionV2List(searchText, filterStatus);
  }

  function openSendUpdate() {
    setRecipientInput("");
    setConfirmStep(false);
    setSendUpdatePopup(true);
  }

  function parseEmails(raw) {
    return raw
      .split(",")
      .map((e) => e.trim())
      .filter(Boolean);
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function handleContinue() {
    const emails = parseEmails(recipientInput);
    if (!emails.length) {
      toast.error("Please enter at least one email address");
      return;
    }
    const invalid = emails.filter((e) => !emailRegex.test(e));
    if (invalid.length) {
      toast.error("Invalid email(s): " + invalid.join(", "));
      return;
    }
    setConfirmStep(true);
  }

  function sendUpdate() {
    setSending(true);
    clientmanageService
      .sendTransitionV2Update({
        emails: parseEmails(recipientInput),
        search: searchText,
        status: filterStatus,
        sort: sortField,
        order: sortOrder,
      })
      .then((response) => {
        setSending(false);
        if (response && response.status === 200) {
          toast.success(response.data.message);
          setSendUpdatePopup(false);
        } else {
          toast.error(
            (response && response.data && response.data.message) ||
              "Something went wrong"
          );
        }
      });
  }

  const getStatusColor = (status) => {
    if (status === "Completed") return "green";
    if (status === "In Progress") return "#fb9540";
    return "#888";
  };

  const cardStyle = (active, color) => ({
    cursor: "pointer",
    borderLeft: `4px solid ${color}`,
    boxShadow: active ? `0 0 0 2px ${color}` : undefined,
    transition: "all 0.2s",
  });

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <Row className="align-items-center row">
              <Col xl="10">
                <Button
                  className="dash-button"
                  color="primary"
                  type="button"
                  onClick={() => history.push("/admin/add-sme-transition-v2")}
                >
                  + Add Transition
                </Button>{" "}
                <Button
                  className="dash-button"
                  color="primary"
                  type="button"
                  onClick={() =>
                    history.push("/admin/sme-transition-v2-master")
                  }
                >
                  Manage Master Checklist
                </Button>
              </Col>
            </Row>
            <br />

            {/* Summary Cards */}
            <Row>
              <Col xl="3" md="6" sm="6">
                <Card
                  className="shadow mb-3"
                  style={cardStyle(filterStatus === "all", "#5e72e4")}
                  onClick={() => setFilterStatus("all")}
                >
                  <div style={{ padding: "20px" }}>
                    <h5 className="text-muted mb-0">Total</h5>
                    <h2 className="mb-0" style={{ color: "#5e72e4" }}>
                      {summary.total}
                    </h2>
                  </div>
                </Card>
              </Col>
              <Col xl="3" md="6" sm="6">
                <Card
                  className="shadow mb-3"
                  style={cardStyle(filterStatus === "Not Started", "#888")}
                  onClick={() => setFilterStatus("Not Started")}
                >
                  <div style={{ padding: "20px" }}>
                    <h5 className="text-muted mb-0">Not Started</h5>
                    <h2 className="mb-0" style={{ color: "#888" }}>
                      {summary.not_started}
                    </h2>
                  </div>
                </Card>
              </Col>
              <Col xl="3" md="6" sm="6">
                <Card
                  className="shadow mb-3"
                  style={cardStyle(filterStatus === "In Progress", "#fb9540")}
                  onClick={() => setFilterStatus("In Progress")}
                >
                  <div style={{ padding: "20px" }}>
                    <h5 className="text-muted mb-0">In Progress</h5>
                    <h2 className="mb-0" style={{ color: "#fb9540" }}>
                      {summary.in_progress}
                    </h2>
                  </div>
                </Card>
              </Col>
              <Col xl="3" md="6" sm="6">
                <Card
                  className="shadow mb-3"
                  style={cardStyle(filterStatus === "Completed", "#2dce89")}
                  onClick={() => setFilterStatus("Completed")}
                >
                  <div style={{ padding: "20px" }}>
                    <h5 className="text-muted mb-0">Completed</h5>
                    <h2 className="mb-0" style={{ color: "#2dce89" }}>
                      {summary.completed}
                    </h2>
                  </div>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col xl="12">
                <Card className="shadow">
                  <CardHeader className="bg-transparent">
                    <Row className="align-items-center">
                      <div className="col-4">
                        <h4 className="text-uppercase text-muted ls-1 mb-1">
                          Transition List
                          {filterStatus !== "all" && (
                            <span
                              style={{
                                marginLeft: "10px",
                                color: getStatusColor(filterStatus),
                                fontSize: "12px",
                              }}
                            >
                              (Filtered: {filterStatus})
                            </span>
                          )}
                        </h4>
                      </div>
                      <div className="col-5">
                        <Input
                          placeholder="Search client..."
                          type="text"
                          className="search-box"
                          style={{ fontWeight: "600", color: "black" }}
                          onKeyUp={handleSearch}
                        />
                      </div>
                      <Col xl="3">
                        <Button
                          className="btn-icon-clipboard"
                          type="button"
                          onClick={downloadReport}
                          style={{ textAlign: "center" }}
                          title="Download Report"
                        >
                          <i
                            className="fas fa-download"
                            style={{ fontSize: "14px" }}
                          ></i>{" "}
                          Export
                        </Button>
                        {canSendUpdate && (
                          <Button
                            className="btn-icon-clipboard"
                            type="button"
                            onClick={openSendUpdate}
                            style={{ textAlign: "center" }}
                            title="Send Update"
                          >
                            <i
                              className="fas fa-envelope"
                              style={{ fontSize: "14px" }}
                            ></i>{" "}
                            Send Update
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </CardHeader>
                  <Table
                    className="align-items-center table-flush"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th
                          scope="col"
                          className="whitespace"
                        >
                          Sr No
                        </th>
                        <th
                          scope="col"
                          className="whitespace"
                          onClick={() => sortTable("c.name")}
                          style={{ cursor: "pointer" }}
                        >
                          Client Name
                        </th>
                        <th scope="col" className="whitespace">
                          Sub Client Name
                        </th>
                        <th scope="col" className="whitespace">
                          Responsible TL
                        </th>
                        <th scope="col" className="whitespace">
                          Transition Date
                        </th>
                        <th scope="col" className="whitespace">
                          Status
                        </th>
                        <th scope="col" className="whitespace">
                          Pending Count
                        </th>
                        <th scope="col" className="whitespace">
                          % Completion
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {listData && listData.length > 0 ? (
                        listData.map((item, i) => (
                          <tr
                            key={i}
                            className={
                              i % 2 === 0 ? "purple-row" : "orange-row"
                            }
                          >
                            <td className="whitespace">{i + 1}</td>
                            <td className="whitespace">{item.client_name}</td>
                            <td
                              className="whitespace"
                              style={{
                                cursor: "pointer",
                                color: "#5e72e4",
                                textDecoration: "underline",
                              }}
                              onClick={() =>
                                history.push(
                                  "/admin/sme-transition-v2-detail/" +
                                    item.sub_client_id
                                )
                              }
                            >
                              {item.sub_client_name}
                            </td>
                            <td className="whitespace">
                              {item.responsible_tl || "-"}
                            </td>
                            <td className="whitespace">
                              {item.transition_date
                                ? formatDate(item.transition_date)
                                : "-"}
                            </td>
                            <td
                              className="whitespace"
                              style={{
                                color: getStatusColor(item.status),
                                fontWeight: "600",
                              }}
                            >
                              {item.status}
                            </td>
                            <td
                              className="whitespace"
                              style={{
                                fontWeight: "600",
                                color: item.pending_count > 0 ? "#fb9540" : "#888",
                              }}
                            >
                              {item.pending_count || 0}
                            </td>
                            <td className="whitespace">
                              {item.completion_percentage}%
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8}>No Data Found!</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        <Modal
          isOpen={sendUpdatePopup}
          toggle={() => setSendUpdatePopup(false)}
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title">Send Transition Update</h5>
            <button
              type="button"
              className="close"
              onClick={() => setSendUpdatePopup(false)}
            >
              <span>&times;</span>
            </button>
          </div>
          <ModalBody>
            {!confirmStep ? (
              <Row>
                <Col md="12">
                  {listData.length === 0 && (
                    <p style={{ color: "#f5365c", fontWeight: "600" }}>
                      No records in the current view. Nothing to send.
                    </p>
                  )}
                  <FormGroup>
                    <label className="form-control-label">
                      Recipient Email Addresses
                    </label>
                    <Input
                      type="textarea"
                      placeholder="email1@domain.com, email2@domain.com"
                      value={recipientInput}
                      onChange={(e) => setRecipientInput(e.target.value)}
                    />
                    <small className="text-muted">
                      Comma-separated email addresses
                    </small>
                  </FormGroup>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col md="12">
                  <p>
                    Send the current transition view ({listData.length}{" "}
                    record(s), Filter: {filterStatus}
                    {searchText ? `, Search: "${searchText}"` : ""}) to:
                  </p>
                  <ul>
                    {parseEmails(recipientInput).map((email, i) => (
                      <li key={i}>{email}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            {!confirmStep ? (
              <>
                <Button
                  color="primary"
                  onClick={handleContinue}
                  disabled={listData.length === 0}
                >
                  Continue
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setSendUpdatePopup(false)}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="primary"
                  onClick={sendUpdate}
                  disabled={sending}
                >
                  {sending ? "Sending..." : "Confirm Send"}
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setConfirmStep(false)}
                  disabled={sending}
                >
                  Back
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

const formatDate = (dateStr) => {
  if (dateStr != "" && dateStr != null) {
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  }
  return null;
};

export default SmeTransitionV2List;
